import { useEffect, useState } from 'react';
import api from '../api/api';

export default function useBusinessAddress() {
  const [address, setAddress] = useState(null);

  useEffect(() => {
    let active = true;
    api.get('/locations/business')
      .then((response) => {
        if (active) setAddress(response.data || null);
      })
      .catch((error) => {
        console.error('Failed to load business address:', error);
      });
    return () => {
      active = false;
    };
  }, []);

  return address;
}
